import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.7 20.67"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20.3 8.12 3.39.25C2.52-.18 1.53-.05.81.6c-.74.66-1 1.7-.66 2.64l2.48 7.1-2.47 7.08c-.35.88-.11 1.89.6 2.58.45.44 1.04.68 1.64.68.35 0 .68-.08.99-.23l16.93-7.88c.85-.43 1.38-1.28 1.38-2.22s-.53-1.79-1.39-2.22Zm-1.02 2.93L2.59 18.81c-.28.14-.5-.04-.59-.12-.07-.07-.29-.32-.16-.64l2.44-7h14.99ZM4.29 9.63l-2.44-7c-.09-.26-.04-.51.15-.68.16-.15.37-.2.61-.08l16.67 7.76z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }